<!--
 * @Author: Ashley.Liu
 * @Date: 2022-04-21 14:07:44
 * @LastEditTime: 2022-05-17 14:55:24
 * @Description: desc
-->
<template>
  <div
    class="version-change-log-box"
    v-loading="loading"
  >
    <zm-scrollbar>
      <zm-collapse
        v-model="activeNames"
        @change="handleChange"
        v-if="changeLogTrans && changeLogTrans.length"
      >
        <zm-collapse-item
          v-for="(item, index) in changeLogTrans"
          :name="item.version"
          :key="item.version"
        >
          <div slot="title">
            <span style="color: #0E71EB;">{{ `# ${item.version}`}}</span>
            <template v-if="!readonly">
              <zm-button
                type="icon"
                icon="zm-icon-edit"
                @click.prevent.stop="editChangelog(index)"
                style="color: #6e6e85"
                class="mgl-md"
              ></zm-button>
              <zm-button
                type="icon"
                icon="zm-icon-delete"
                @click.prevent.stop="deleteChangeLog(index)"
                style="color: #6e6e85"
              ></zm-button>
              <Copy
                type='normal'
                :content="item.content"
                class="mgl-sm"
              ></Copy>
            </template>
          </div>

          <div v-html="item.htmlContent">
          </div>

        </zm-collapse-item>
      </zm-collapse>
      <div
        class="no-data"
        v-else
      >
        no data
      </div>
    </zm-scrollbar>
  </div>
</template>

<script>
import MarkdownIt from 'markdown-it'
import { getUsafeConfig, insertUnsafeConfig } from '@/api/unsafeConfig'
import Copy from '@/components/Copy'
export default {
  components: {
    Copy
  },
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      activeNames: [],
      loading: true,
      changeLogTrans: [],
      changeLogs: []
    }
  },
  watch: {
    visible (v) {
      if (v) {
        this.getChangeLogs()
      }
    },
    changeLogs: {
      deep: true,
      immediate: true,
      handler (v) {
        if (v?.length) {
          const md = new MarkdownIt()
          this.changeLogTrans = v?.map((item) => {
            const html = md.render(item.content)
            return {
              ...item,
              htmlContent: html
            }
          })
        }
      }
    }
  },
  created () {
    this.getChangeLogs()
  },
  methods: {
    handleChange (val) {
      console.log(val)
    },
    refresh () {
      this.getChangeLogs()
    },
    getChangeLogs () {
      this.loading = true
      getUsafeConfig('changeLog').then(({ data }) => {
        this.loading = false
        this.changeLogs = data?.value && JSON.parse(data?.value)
        this.activeNames = [this.changeLogs?.[0]?.version]
      }).catch(() => {
        this.loading = false
      })
    },
    editChangelog (index) {
      this.$emit('edit', index)
    },
    deleteChangeLog (index) {
      this.$confirm('This will delete the changelog. Continue?', 'Warning', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.changeLogs.splice(index, 1)
        insertUnsafeConfig({ unsafeConfigMap: { changeLog: JSON.stringify(this.changeLogs) } }).then(() => {
          this.$message.success('Successfully deleted!')
          this.$emit('deleted', this.changeLogs)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.version-change-log-box {
  overflow-y: auto;
  border: 1px solid #e3e3e9;
  border-radius: 8px;
  padding: 20px;
  p {
    line-height: 1.1;
    margin-block-start: 0;
    margin-block-end: 0;
  }
  .no-data {
    text-align: center;
    color: #6e7680;
  }
}
::v-deep .zm-collapse {
  border-top: none;
  border-bottom: 1px solid #e3e3e9;
  .zm-collapse-item__header {
    padding-top: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #e3e3e9;
    &.is-active {
      border-bottom-color: #e3e3e9;
    }
  }
  .zm-collapse-item__wrap {
    border-bottom: 1px solid #e3e3e9;
    .zm-collapse-item__content {
      padding-top: 24px;
      padding-bottom: 24px;
    }
  }
  .zm-scrollbar__wrap {
    overflow-x: hidden;
  }
}
::v-deep .async-copy-component {
  display: inline-block;
  width: 24px;
  height: 24px;
  .zm-icon-copy {
    font-size: 12px;
    color: #6e6e85;
  }
}
</style>
